<!-- src/views/AboutUs.vue -->
<template>
  <!--==== ABOUTUS ====-->

  <div :class="['aboutus_home', language === 'cn' ? 'font-cn' : 'font-en']">
    <div class="container">
      <div class="header">
        <h1>{{ content.about_us_title }}</h1>
        <p>{{ content.about_us_description }}</p>
        <!-- <div class="image-container">
          <div class="image">
            <span class="image-text">图片</span>
          </div>
        </div> -->
        <h1>{{ content.contact_us_title }}</h1>
        <p>{{ content.contact_us_description }}</p>
      </div>
    </div>
  </div>
</template>

<style>
/* ABOUTUS */

.container {
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  padding: 20px; /* Optional: Add some padding to make sure content doesn't touch the edges */
  box-sizing: border-box;
  margin-top:auto;
}

.header,
.certificates {
  margin-bottom: 20px;
}

.header h1 {
  font-size: 24px;
  border-bottom: 2px solid #000;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.header p {
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 20px;
  white-space: pre-line;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px; /* Adjust height as needed */
}

.image {
  background-color: #004080;
  width: 50%; /* Adjust width as needed */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  position: relative;
}

.image-text {
  position: absolute;
  color: white;
  font-size: 24px;
}

.desc {
  text-align: left;
}

.certificates {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.certificate {
  background-color: #004080;
  width: 30%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  margin: 10px 0;
}
</style>

<script>
import { mapState } from "vuex";
import en from "@/data/about_us_en.js";
import cn from "@/data/about_us_cn.js";
export default {
  mixins: [en, cn],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
